// extracted by mini-css-extract-plugin
module.exports = {"simplified-banner":"_93444fe79c--simplified-banner--Z6uId","no-banner":"_93444fe79c--no-banner--E8ux1"};